import { styled } from 'parkdepot-shared/theme'

export const BookTicketTitle = styled('h2', ({ $theme }) => ({
    margin: 0,
    ...$theme.typography.LabelLarge,
    fontWeight: 700
}))
